function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2131",
  "data-name": "Grupo 2131",
  transform: "translate(-232 -396)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_346",
  "data-name": "Elipse 346",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(232 396)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("g", {
  id: "warning-icon",
  transform: "translate(232 396)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_540",
  "data-name": "Grupo 540",
  transform: "translate(7.333 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_539",
  "data-name": "Grupo 539"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_858",
  "data-name": "Caminho 858",
  d: "M356.658,55.8a.585.585,0,0,0,.145.4.547.547,0,0,0,.429.163.556.556,0,0,0,.432-.163.578.578,0,0,0,.147-.4A.6.6,0,0,0,356.8,55.4.564.564,0,0,0,356.658,55.8Zm1.053-7.208h-.974v5.7h.974Z",
  transform: "translate(-356.658 -48.59)",
  fill: "#4d4b4b"
})))));

function SvgWarningFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warning-filled.bf7a7ccc.svg";
export { ForwardRef as ReactComponent };